<template>
	<div>
		<label for="sort-by">Sort by</label> 
		<select id="sort-by" v-model="sortBy" @change="change">
			<option value="manual">Featured</option>
			<option value="price-ascending">Price: Low to High</option>
			<option value="price-descending">Price: High to Low</option>
			<option value="title-ascending">A-Z</option>
			<option value="title-descending">Z-A</option>
			<option value="created-ascending">Oldest to Newest</option>
			<option value="created-descending">Newest to Oldest</option>
			<option value="best-selling">Best Selling</option>
		</select>
	</div>
</template>

<script>
export default {
	name: "Sort",
	selector: "#vue-sort",
	data() {
		return {
			sortBy: ''
		}
	},
	methods: {
		change(e) {
			Shopify.queryParams.sort_by = e.target.value;
			const params = Object.keys(Shopify.queryParams).map((k) => encodeURIComponent(k) + '=' + encodeURIComponent(Shopify.queryParams[k])).join('&').replace(/\+/g, '%20');
			location.search = params;
		}
	},
	mounted() {
		Shopify.queryParams = {};
		if (location.search.length) {
			for (var aKeyValue, i = 0, aCouples = location.search.substr(1).split('&'); i < aCouples.length; i++) {
				aKeyValue = aCouples[i].split('=');
				if (aKeyValue.length > 1) {
					Shopify.queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]);
				}
			}
		}
		this.sortBy = Shopify.queryParams.sort_by;
	}
}
</script>